import React, { useMemo } from "react";
import { useStore } from "../../../store";

import { Accordion, Type } from "@ebscois/react-component-library";
import {
  StyledContentContributorInfoContainer,
  StyledContentContributorAccordionHeader,
  StyledAffiliationsType,
  StyledConflictOfInterestType,
  StyledAcpAccordionHeader,
  StyledAcpLogo,
  StyledAcpContainer,
  StyledAcpLabel,
} from "./_styled";

const ContentContributorInfo = ({
  contributors,
  isContributorNamesDialogEnabled,
}) => {
  const { contributorLogos } = useStore();
  const acpContributor = useMemo(
    () => contributors.find((contributor) => contributor.acpContributor),
    [contributors]
  );

  if (isContributorNamesDialogEnabled) {
    if (!acpContributor) {
      return null;
    }

    return (
      <StyledAcpContainer>
        <StyledAcpLabel fontSize="xs">
          {acpContributor.acpContributor}
        </StyledAcpLabel>
        <StyledAcpLogo
          src={contributorLogos?.acp.src}
          alt={contributorLogos?.acp.alt}
        />
      </StyledAcpContainer>
    );
  }

  return (
    <StyledContentContributorInfoContainer data-testid="content-contributor-info">
      {contributors
        .filter((contributor) => !contributor.acpContributor)
        .map((contributor) => (
          <Accordion
            variant="tertiary"
            scrollable
            size="md"
            toggleText={
              <StyledContentContributorAccordionHeader
                data-testid="content-contributor-nonAcp"
                rowOne={contributor.label}
                rowTwo={`${contributor.givenName} ${contributor.surname} ${contributor.degrees}`}
              />
            }
          >
            <StyledAffiliationsType
              element="h5"
              styledAs="span"
              fontSize="sm"
              fontWeight="semibold"
              color="gray800"
            >
              Affiliations
            </StyledAffiliationsType>
            <Type element="p" fontSize="sm" color="gray800">
              {contributor.affiliationText}
            </Type>
            {contributor.conflictsText && (
              <React.Fragment>
                <StyledConflictOfInterestType
                  element="h5"
                  styledAs="span"
                  fontSize="sm"
                  fontWeight="semibold"
                  color="gray800"
                >
                  Conflicts of Interest
                </StyledConflictOfInterestType>
                <Type element="p" fontSize="sm" color="gray800">
                  {contributor.conflictsText}
                </Type>
              </React.Fragment>
            )}
          </Accordion>
        ))}
      {acpContributor && (
        <Accordion
          variant="tertiary"
          scrollable
          size="md"
          toggleText={
            <StyledAcpAccordionHeader
              data-testid="content-contributor-acp"
              variant="secondary"
              rowOne={acpContributor.acpContributor}
              rowTwo={
                <StyledAcpLogo
                  src={contributorLogos?.acp.src}
                  alt={contributorLogos?.acp.alt}
                />
              }
            />
          }
        />
      )}
    </StyledContentContributorInfoContainer>
  );
};

ContentContributorInfo.displayName = "ContentContributorInfo";

export default ContentContributorInfo;
